import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageItem } from 'src/app/shared/ui/sera-image/models/image-item';

@Component({
    selector: 'sera-image-container',
    templateUrl: './sera-image-container.component.html',
    styleUrls: ['./sera-image-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraImageContainerComponent {
    @Input()
    imageItems!: ImageItem[];

    @Input()
    numberOfColumns: number = 4;

    @Input()
    readOnly: boolean = false;

    /**
     * Gap between columns in pixels.
     * If not specified, columns are spaced between each other to fill parent container.
     */
    @Input()
    columnGapInPx?: number;

    @Input()
    rowGapInPx?: number = 24;

    @Input()
    transparentImages: boolean = false;

    @Input()
    multiSelect: boolean = false;

    @Output()
    imageSelectionChanged: EventEmitter<number> = new EventEmitter<number>();

    @Output()
    imageSelectionChangedMulti: EventEmitter<number[]> = new EventEmitter<number[]>();

    handleImageSelection(imageId: number): void {
        if (this.multiSelect) {
            this.imageItems = this.imageItems.map(image => (image.id === imageId ? { ...image, isSelected: !image.isSelected } : image));
            const selectedIds = this.imageItems.filter(image => image.isSelected).map(image => image.id);
            this.imageSelectionChangedMulti.emit(selectedIds);
        } else {
            this.imageItems = this.imageItems.map(image => ({
                ...image,
                isSelected: image.id === imageId
            }));
            this.imageSelectionChanged.emit(imageId);
        }
    }
}
